module.exports = __webpack_public_path__ + "static/media/031.4bfa5b77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/031.jpg
// module id = 504
// module chunks = 0